import React, { createContext, useEffect, useState } from 'react';

// Create the context
export const GlobalContext = createContext();

// Create a provider component
export const GlobalProvider = ({ children }) => {
    const [globalEmail, setGlobalEmail] = useState('');
    const [globalId, setGlobalId] = useState(0); // user id of logged in user
    // Manage Assets -> property manager
    const [managePropertyTab, setManagePropertyTab] = useState('Basic');
    // manage assets general id
    const [manageAssetId, setManageAssetId] = useState(0);

    // asset manager
    const [transactionId, setTransactionId] = useState(0);
    const [loanId, setLoanId] = useState(0);
    const [constructionId, setConstructionId] = useState(0);
    const [rentalId, setRentalId] = useState(0);

    const assetManager = {
        transactionId,
        setTransactionId,
        loanId,
        setLoanId,
        constructionId,
        setConstructionId,
        rentalId,
        setRentalId,
    };
    const [manageRecordTab, setManageRecordTab] = useState('Investors');
    const [recordManagerAdminTab, setRecordManagerAdminTab] = useState('KPI');
    const [manageRecordId, setManageRecordId] = useState(0);
    const [investorIdToView, setInvestorIdToView] = useState(-1); // investor id that is currently displaying
    const [accessToken, setAccessToken] = useState('');
    // id of transaction being paid / unpaid, will send email about that transaction
    const [emailNoticeTransactionId, setEmailNoticeTransactionId] =
        useState(-1);
    // payout summary
    const [payoutsRaw, setPayoutsRaw] = useState([]);
    // payout summary columns -> width
    const [payoutsColumns, setPayoutsColumns] = useState({
        'Investment Entity': 150,
        Investor: 150,
        Fund: 150,
        'Payment Company': 150,
        'Start Date': 100,
        'End Date': 100,
        Currency: 100,
        Frequency: 100,
        Interest: 50,
        'Invested Amount': 100,
        'Account Balance': 100,
        Amount: 100,
        Type: 100,
        'Next Payment Date': 100,
        'Next Payment Due': 100,
        Status: 80,
        Pay: 80,
    });

    // filters for payouts
    const [filters, setFilters] = useState({
        startDate: '',
        useStartDate: false,
        endDate: '',
        useEndDate: false,
        fundFilter: -1,
        paymentCompanyFilter: -1,
        closedWithinPeriod: {
            active: false,
        },
        paymentStatus: {
            paid: true,
            unpaid: true,
        },
        investmentStatus: 'Active',
        type: {
            principal: true,
            'principal Taken Out': true,
            interest: true,
            'final Payout': true,
        },
    });
    const [tableView, setTableView] = useState('default');
    const [initialAccessToken, setInitialAccessToken] = useState(true);
    const [accessTokenExpiredTime, setAccessTokenExpiredTime] = useState(0);
    useEffect(() => {
        if (accessToken == '') return;
        if (!initialAccessToken) return;
        setInitialAccessToken(false);
        setAccessTokenExpiredTime(Date.now() + (86400 - 60) * 1000); // 20 minutes from now
    }, [accessToken]);
    const [refreshSession, setRefreshSession] = useState(() => () => {});
    const [payoutTableColumnsToShow, setPayoutTableColumnsToShow] = useState(
        Object.fromEntries(
            Object.keys(payoutsColumns).map((key) => [key, true])
        )
    );

    const [payoutTableWidth, setPayoutTableWidth] = useState(
        Object.entries(payoutTableColumnsToShow).reduce(
            (sum, [key, isVisible]) => {
                return isVisible ? sum + (payoutsColumns[key] || 0) : sum;
            },
            0
        )
    );

    const [offeringFilter, setOfferingFilter] = useState({
        'Investment Type': ['Equity', 'Debt'],
        'Investment Status': ['New', 'Open', 'Closed'],
        'Minimum Investment': [0, 200000],
        Term: ['0-6 Months', '6-24 Months', '24 Months+'],
    });

    useEffect(() => {
        if (tableView === 'default') {
            setPayoutTableColumnsToShow((prev) => {
                return { ...prev, Account: true };
            });
        } else if (tableView === 'accounting') {
            setPayoutTableColumnsToShow((prev) => {
                return { ...prev, 'Payment Company': true };
            });
        }
    }, [tableView]);

    useEffect(() => {
        setPayoutTableWidth(
            Object.entries(payoutTableColumnsToShow).reduce(
                (sum, [key, isVisible]) => {
                    return isVisible ? sum + (payoutsColumns[key] || 0) : sum;
                },
                0
            )
        );
    }, [payoutsColumns, payoutTableColumnsToShow]);

    return (
        <GlobalContext.Provider
            value={{
                globalEmail,
                setGlobalEmail,
                globalId,
                setGlobalId,
                manageRecordTab,
                setManageRecordTab,
                manageRecordId,
                setManageRecordId,
                investorIdToView,
                setInvestorIdToView,
                accessToken,
                setAccessToken,
                managePropertyTab,
                setManagePropertyTab,
                manageAssetId,
                setManageAssetId,
                assetManager,
                payoutsRaw,
                setPayoutsRaw,
                filters,
                setFilters,
                tableView,
                setTableView,
                accessTokenExpiredTime,
                setAccessTokenExpiredTime,
                refreshSession,
                setRefreshSession,
                payoutsColumns,
                setPayoutsColumns,
                payoutTableColumnsToShow,
                setPayoutTableColumnsToShow,
                payoutTableWidth,
                accessTokenExpiredTime,
                setAccessTokenExpiredTime,
                refreshSession,
                setRefreshSession,
                offeringFilter,
                setOfferingFilter,
                emailNoticeTransactionId,
                setEmailNoticeTransactionId,
                recordManagerAdminTab,
                setRecordManagerAdminTab,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};
